import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {GetSupplierOrderVariantsResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromSupplierOrderVariants = (
  supplierOrderVariants: GetSupplierOrderVariantsResponse[] | Nullish
): Option[] => {
  if (isNil(supplierOrderVariants)) {
    return [];
  }
  return supplierOrderVariants.map((supplierOrderVariant) => ({
    label: supplierOrderVariant.name,
    value: supplierOrderVariant.orderVariantId,
  }));
};
